import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    Button,
    Grid,
    Modal,
    Image,
		Item,
    Header,
    Icon
} from 'semantic-ui-react';

import './modalRechercheProduit.css';


import { translate } from "react-translate";
import Exit from '../../../assets/svg/Exit.svg';
import defautImage from '../../../assets/default/default.png';
import AddToList from '../../../assets/svg/add-to-list.svg';
import FicheFournisseur from '../../../assets/svg/fiche_fournisseur.svg';
import Tutoriel from '../../../assets/svg/tutoriel.svg';
import ModalAddToList from '../Travaux/ModalAddToList'

import {
  addModalAddToList,
  addToList,
  addList,
  addArticle,
  addAtlError
} from '../../../redux/actions/ConfigFileAction';

import API from '../../../services/api';


const mapActionToProps = {
  addToList: addToList,
  addList: addList,
  addArticle: addArticle,
	addAtlError: addAtlError,
	addModalAddToList: addModalAddToList
};


const mapStateToProps = state => ({
    app: state.app
})

class ModalRechercheProduit extends Component {
    constructor(props) {
        super(props);

        this.state = {
          configFileLang: this.props.configFileLang,
        }

        this.handleAddToList = this.handleAddToList.bind(this);
        this.handleOpenFicheFournisseur = this.handleOpenFicheFournisseur.bind(this);
        this.handleOpenFicheTuto = this.handleOpenFicheTuto.bind(this);
        this.openModal = this.openModal.bind(this);
    }

    openModal() {
      var self = this;
      var listData = {
        fkuiduser : this.props.app.id
      };
      var article = this.props.produit;
      API.getList(this.props.app.token, listData).then((res) => {
        this.props.addToList(true);
        this.props.addList(res.data.lists);
        this.props.addArticle([article]);
        this.props.addModalAddToList(true);
        this.props.addAtlError(false);
      });
    }

    handleAddToList(event) {
      this.openModal();
    }
    handleOpenFicheFournisseur(produit) {
      // Open fiche in new tab
      if(produit.link_article && produit.link_article.length > 0) {
        // TODO maybe check if hosted on our domain or not.
        window.open(API.resourceURL + '/upload/' + produit.link_article, '_blank')
      }
    }

    handleOpenFicheTuto(produit) {
      if(produit.link_tutorial && produit.link_tutorial.length > 0 ) {
        window.open(produit.link_tutorial, '_blank')
      }
    }
    render() {
        const { t, produit } = this.props


        return (
            <Modal size='large' open={this.props.isOpen} onClose={this.props.onCloseCallback}>

                {/*<Modal.Header id="modalHeader">
                  modal recherche produit
                </Modal.Header>*/}

                <Modal.Header id="modalHeader">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column textAlign='center'>
                                <Image
                                    id="modalExit"
                                    onClick={() => this.props.onCloseCallback()}
                                    src={Exit}
                                    floated='right' />
                                <Header
                                    as='h2'
                                    id="modalTitle"
                                    textAlign='center'>
                                    {t("modal_titre")}
                              </Header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>

                { produit &&

                  <Modal.Content scrolling id="modalRechercheProduit">

                    <Grid>
                      <Grid.Row verticalAlign='top'>
                        <Grid.Column computer={5} tablet={5} mobile={16}>
                            <Image wrapped size='medium' src={produit.image || defautImage} />
                            <Button icon labelPosition='left' fluid className="infoBtnModalRecherche" onClick={() => this.handleOpenFicheFournisseur(produit)}>
                              <Icon><Image src={FicheFournisseur} /></Icon>
                              {t("Btn2_text")}
                            </Button>
                            <Button icon labelPosition='left' fluid className="infoBtnModalRecherche" onClick={() => this.handleOpenFicheTuto(produit)}>
                              <Icon><Image src={Tutoriel} /></Icon>
                              {t("Btn3_text")}
                            </Button>
                        </Grid.Column>

                      <Grid.Column computer={8} tablet={7} mobile={16}>
                        <Modal.Description>
                          <Header as='h3'>{produit.title}</Header>
                          {/* <h4>{produit.description}</h4> */}
                          <h5 className="ref">{t("reference")}: {produit.pkuidga}</h5>
                          {/* <p>{t("referenceSurface")}</p>
                          <p>{t("referenceMarque")}</p>
                          <p>{t("referenceLargeur")}</p> */}
                          {/* <h5 className="description">{t("description")}</h5> */}
                          <p>
                            {produit.description}
                          </p>
                          <Button icon labelPosition='left'
                            onClick={(e) => this.handleAddToList(e)}
                          >
                            <Icon><Image src={AddToList} /></Icon>
                            {t("Btn1_text")}
                          </Button>
                          <ModalAddToList lang={this.state.configFileLang} />
                        </Modal.Description>
                      </Grid.Column>
                      <Grid.Column computer={3} tablet={4} mobile={16}>
                        <div className="price-box">
                          {produit.priceTitle}
                          <span className="price">{produit.price}</span>
                          <span className="priceCurrency">{produit.currency}€</span>
                          <span className="unit">/Unité</span>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                    </Grid>
                  </Modal.Content>

                }

          </Modal>
        )
    }
}
const SearchModal = connect(mapStateToProps, mapActionToProps)(ModalRechercheProduit);
export default translate("ModalRechercheProduit")(SearchModal);



// WEBPACK FOOTER //
// ./src/components/Protected/Recherche/ModalRechercheProduit.jsx